/**
 * Role-based route guards: admin-only and super-admin-only routes.
 * Non-qualifying users are redirected to /app (Dashboard).
 */
import { Navigate } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';

interface AdminOnlyRouteProps {
  children: React.ReactNode;
}

export function AdminOnlyRoute({ children }: AdminOnlyRouteProps) {
  const { userProfile, loading } = useApp();

  if (loading) {
    return null;
  }

  if (userProfile?.role !== 'admin') {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}

/**
 * Super-admin route guard: requires both role='admin' AND is_super_admin=true.
 * Operator admins (role='admin' but not super_admin) are redirected.
 */
export function SuperAdminOnlyRoute({ children }: AdminOnlyRouteProps) {
  const { userProfile, loading } = useApp();

  if (loading) {
    return null;
  }

  if (userProfile?.role !== 'admin' || !userProfile?.is_super_admin) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
